import { getUrlApi } from '../utilities/util';
import ApiHandler from './ApiHandlers/ApiHandler';

export const baseURL = String(getUrlApi());

export default class UserConfigApi {

    static async GetUserConfigs(userId: string): Promise<any> {
      return ApiHandler(baseURL).get("users/getconfig/" + userId);
    };

    static async CreateConfig( config: any): Promise<any> {
        const form = {
            id: config.id,
            userId: config.userId,
            platform: config.platform.label,
            baseUrl: config.url,
            userName: config.username,
            token: config.token,
            isActive: config.isActive,
            projectName: config.projectName
        }
        return ApiHandler(baseURL).post("users/CreateConfig" , form )
    };

    static async EditUserConfigs( config: any): Promise<any> {
        const form = {
            id: config.id,
            userId: config.userId,
            platform: config.platform.label,
            baseUrl: config.url,
            userName: config.username,
            token: config.token,
            isActive: config.isActive,
            projectName: config.projectName
        }
        return ApiHandler(baseURL).put("users/editconfig" , form )
    };

    static async DeleteUserConfigs( config: any): Promise<any> {
        const id = config.id
        return ApiHandler(baseURL).delete("users/DeleteConfig/" + id )
    };

    static async UpdateImage(imageBase64: any, imageMetaData: any): Promise<any> {
        return ApiHandler(baseURL).put("users/UpdateImage", {
            base64: imageBase64,
            imageMetaData: imageMetaData
        })
    };

    static async EditSimpleConfigs( config: any): Promise<any> {
        const simpleForm = {
            id: config.id,
            userId: config.userId, 
            nickName: config.nickName,
            image: config.image
        }
        return ApiHandler(baseURL).put("users/editSimpleconfig" , simpleForm )
    };
    
}